import React from "react";

import { useDispatch } from "react-redux";

import { Typography } from "@mui/material";

import CreditCardForm from "../CreditCardForm";
import { agentsAdminAction } from "../../../redux/slices/brokers/agentAdminSlice";

const AddCreditCardForm = ({
  closeAddCardModal = () => {},
  agentCardListAPICall = () => {},
  base_route = "broker",
}) => {
  const dispatch = useDispatch();

  const addCardFormData = (values) => {
    console.log("values-->", values);
    let data = { ...values };
    data.user_id = values?.agent_id;
    delete data?.agent_id;
    delete data?.cvc;
    delete data?.expiry;
    delete data?.number;
    dispatch(
      agentsAdminAction.getAddSaveCardsDetails({
        url: `agent/save-card?source=${base_route}`,
        data,
        brokertoken: true,
      })
    );
  };
  return (
    <div className="add_card_modal">
      <div className="title_texts">
        <Typography variant="body2" className="title">
          Add credit/debit card
        </Typography>
        <Typography variant="body2" className="desc">
          This is where you can add your payment card details
        </Typography>
      </div>
      <div className="d-flex justify-content-center">
        <div className="payment_frame">
          <CreditCardForm
            addCardFromBilling={true}
            closePaymentModal={closeAddCardModal}
            addCardFormData={addCardFormData}
            base_route={base_route}
          />
        </div>
      </div>
    </div>
  );
};

export default AddCreditCardForm;
